import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link } from '@mui/material';
import Async from 'components/Async';
import MediaTypography from 'components/MediaTypography';
import NewsItem from 'modules/News/components/NewsItem';
import store from 'store';

import { getRoute } from '@common/constants/CampusRoutes';

import { NewsListWrapper } from './styled';

function NewsList() {
	const { t } = useTranslation();
	const latestNews = store.news.slice(0, 2);

	if (!latestNews.length) {
		return null;
	}

	return (
		<NewsListWrapper>
			<Async loading={store.loading}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<MediaTypography variant="h3">{t('news.latest')}</MediaTypography>
					<MediaTypography variant="caption">
						<Link href={getRoute(['NEWS'])}>{t('news.all')}</Link>
					</MediaTypography>
				</Box>

				{latestNews.map((newsItem) => (
					<NewsItem newsItem={newsItem} key={newsItem.id} />
				))}
			</Async>
		</NewsListWrapper>
	);
}

export default observer(NewsList);
